import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MasterComponent } from './modules/master/master.component';
import {MsalGuard} from "@azure/msal-angular";

export const loadChildrenMasterSubscriber = (m: any) => m.MasterModule;
export const loadChildrenMaster = () =>
  import('./modules/master/master.module').then(loadChildrenMasterSubscriber);

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./modules/autenticacion/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'app',
    component: MasterComponent,
    canActivate: [AuthGuard],
    loadChildren: loadChildrenMaster,
    data: { breadCrumbTitle: 'Inicio' },
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
